var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.showSummary
        ? _c(
            "component-wrapper",
            { attrs: { spacing: "bottom" } },
            [
              _c("progress-bar", {
                attrs: {
                  id: "progress-bar",
                  currentStep: _vm.currentStep,
                  stepOneTitle: _vm.content.stepOneTitle,
                  stepTwoTitle: _vm.content.stepTwoTitle,
                  stepThreeTitle: _vm.content.stepThreeTitle,
                  stepFourTitle: _vm.content.stepFourTitle
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("step-panel", { attrs: { isVisible: _vm.showStepOne } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSummary,
                expression: "showSummary"
              }
            ]
          },
          [
            _c(
              "component-wrapper",
              { attrs: { spacing: "bottom" } },
              [
                _c("section-header", {
                  attrs: {
                    desc: _vm.content.summaryDesc,
                    title: _vm.content.summaryTitle
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "summary-box",
              { attrs: { summary: _vm.wizard } },
              [
                _c("base-button", { on: { click: _vm.toggleSummary } }, [
                  _vm._v("Back")
                ]),
                _vm._v(" "),
                _c("base-button", { on: { click: _vm.collateAnswers } }, [
                  _vm._v("Continue")
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showSummary,
                expression: "!showSummary"
              }
            ]
          },
          [
            _vm.content.stepOneTitle && _vm.content.stepOneDesc
              ? _c(
                  "component-wrapper",
                  { attrs: { spacing: "bottom" } },
                  [
                    _c("section-header", {
                      attrs: {
                        desc: _vm.content.stepOneDesc,
                        title: _vm.content.stepOneTitle
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.wizard, function(question, index) {
              return _c(
                "component-wrapper",
                { key: question.id, attrs: { id: question.id } },
                [
                  _c(question.type, {
                    tag: "component",
                    attrs: { index: index, question: question },
                    on: {
                      "hook:updated": function($event) {
                        return _vm.scrollToComponent(question.id)
                      },
                      input: _vm.injectNextQuestion
                    }
                  })
                ],
                1
              )
            }),
            _vm._v(" "),
            _vm.offerUpload && _vm.isFinalQuestion
              ? _c(
                  "component-wrapper",
                  { attrs: { spacing: "bottom" } },
                  [
                    _c("upload-box", {
                      attrs: {
                        extensions: _vm.extensions,
                        title: _vm.content.uploadTitle,
                        uploadPostAction: _vm.uploadPostAction
                      },
                      on: { "file-upload": _vm.setFileId }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "component-wrapper",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.isFinalQuestion,
                    expression: "isFinalQuestion"
                  }
                ],
                attrs: { spacing: "bottom" }
              },
              [
                _c(
                  "div",
                  { staticClass: "c-rap-actions" },
                  [
                    _c(
                      "base-button",
                      {
                        attrs: { disabled: _vm.disableWizardContinue },
                        on: { click: _vm.toggleSummary }
                      },
                      [_vm._v("\n              Continue\n            ")]
                    )
                  ],
                  1
                )
              ]
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "step-panel",
        { attrs: { isVisible: _vm.showStepTwo } },
        [
          _vm.content.stepTwoTitle && _vm.content.stepTwoDesc
            ? _c(
                "component-wrapper",
                { attrs: { spacing: "bottom" } },
                [
                  _c("section-header", {
                    attrs: {
                      desc: _vm.content.stepTwoDesc,
                      title: _vm.content.stepTwoTitle
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "component-wrapper",
            { attrs: { spacing: "bottom" } },
            [
              _c("location-box", {
                attrs: {
                  contactDetailsRequestError: _vm.contactDetailsRequestError,
                  contactDetailsRequestErrorText:
                    _vm.contactDetailsRequestErrorText,
                  backButtonText: _vm.content.backButtonText,
                  continueButtonText: _vm.content.continueButtonText,
                  componentId: _vm.componentId,
                  customerAccountReferenceLabel:
                    _vm.content.customerAccountReferenceLabel,
                  customerLocationValidationError:
                    _vm.content.customerLocationValidationError,
                  isLoading: _vm.isLoading,
                  locationNotFound: _vm.content.locationNotFound,
                  locationNotListed: _vm.content.locationNotListed,
                  locationNotValid: _vm.content.locationNotValid,
                  locationValid: _vm.locationValid,
                  notFound: _vm.notFound,
                  postcodeLabel: _vm.content.postcodeLabel,
                  suggestedAddresses: _vm.suggestedAddresses,
                  tryAgainButtonText: _vm.content.tryAgainButtonText
                },
                on: {
                  addressChange: _vm.addressChange,
                  locationRequest: _vm.getContactDetails,
                  locationReset: _vm.resetSuggestedAddresses,
                  stepChange: _vm.stepChange,
                  validateCustomer: _vm.validateCustomer
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("step-panel", { attrs: { isVisible: _vm.showStepThree } }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showSummary,
                expression: "showSummary"
              }
            ]
          },
          [
            _c(
              "component-wrapper",
              { attrs: { spacing: "bottom" } },
              [
                _c("section-header", {
                  attrs: {
                    desc: _vm.content.summaryDesc,
                    title: _vm.content.summaryTitle
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "summary-box",
              { attrs: { isLoading: _vm.isLoading, summary: _vm.details } },
              [
                _c("base-button", { on: { click: _vm.resetDetails } }, [
                  _vm._v("Back")
                ]),
                _vm._v(" "),
                _c("base-button", { on: { click: _vm.postIncidentReport } }, [
                  _vm._v("Continue")
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showSummary,
                expression: "!showSummary"
              }
            ]
          },
          [
            _vm.content.stepThreeTitle && _vm.content.stepThreeDesc
              ? _c(
                  "component-wrapper",
                  { attrs: { spacing: "bottom" } },
                  [
                    _c("section-header", {
                      attrs: {
                        desc: _vm.content.stepThreeDesc,
                        title: _vm.content.stepThreeTitle
                      }
                    })
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "component-wrapper",
              { attrs: { spacing: "bottom" } },
              [
                _c("form-box", {
                  attrs: {
                    aboutYouEmailLabel: _vm.content.aboutYouEmailLabel,
                    aboutYouFirstNameLabel: _vm.content.aboutYouFirstNameLabel,
                    aboutYouOtherTitleLabel:
                      _vm.content.aboutYouOtherTitleLabel,
                    aboutYouPrimaryContactLabel:
                      _vm.content.aboutYouPrimaryContactLabel,
                    aboutYouSecondaryContactLabel:
                      _vm.content.aboutYouSecondaryContactLabel,
                    aboutYouSurnameLabel: _vm.content.aboutYouSurnameLabel,
                    aboutYouTitleLabel: _vm.content.aboutYouTitleLabel,
                    backButtonText: _vm.content.backButtonText,
                    continueButtonText: _vm.content.continueButtonText,
                    email: _vm.formBoxData.email,
                    firstName: _vm.formBoxData.firstName,
                    surname: _vm.formBoxData.surname,
                    otherTitle: _vm.formBoxData.otherTitle,
                    primaryContact: _vm.formBoxData.primaryContact,
                    secondaryContact: _vm.formBoxData.secondaryContact,
                    title: _vm.formBoxData.title
                  },
                  on: {
                    collateDetails: _vm.collateDetails,
                    stepChange: _vm.stepChange,
                    valueChange: _vm.formBoxValueChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "step-panel",
        { attrs: { isVisible: _vm.showStepFour } },
        [
          _c(
            "component-wrapper",
            { attrs: { spacing: "bottom" } },
            [
              _c("confirmation-box", {
                attrs: {
                  message: _vm.confirmationMessage,
                  reference: _vm.confirmationReference,
                  title: _vm.confirmationTitle,
                  confirmationCtaUrl: _vm.content.stepFourConfirmationCtaUrl,
                  confirmationCtaText: _vm.content.stepFourConfirmationCtaText
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f19f3398", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f19f3398","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/reportAProblem/report-a-problem/_vue/ReportProblem.vue
// module id = 659
// module chunks = 0